import React from "react";

const EntriesSelector = ({ limit, onLimitChange, options }) => {
  return (
    <div className="entries-selector d-flex align-items-center gap-2 flex-wrap">
      <label className="fw-medium text-secondary mb-0 d-flex align-items-center">
        Show
        <select
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          className="form-select form-select-sm ms-2"
          style={{
            minWidth: "80px",
            borderRadius: "10px",
            borderColor: "#dee2e6",
            boxShadow: "none",
          }}
        >
          {options.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>

      
    </div>
  );
};

export default EntriesSelector;
